<template>
  <div class="login d-flex justify-center">
    <div class="login-area d-flex justify-center" :class="{'width-all': firstTextIsRead && !showBgImage }">
      <div class="language-switcher">
        <Button
          block
          dark
          tabindex="1"
          height="30"
          :class="{ 'active-language': currentLang === 'en' }"
          @click.native="updateLanguage('en')">
          English
        </Button>
        <Button
          block
          dark
          tabindex="2"
          height="30"
          :class="{ 'active-language': currentLang === 'es' }"
          @click.native="updateLanguage('es')">
          Spanish
        </Button>
      </div>
      <div class="login-area__form-wrapper d-flex flex-column">
        <div class="logo flex-grow-1 d-flex align-center" style="column-gap: 10px;">
          <Img :src="responseResult?.logoSmall" width="97" />
          <div style="width: 70%">
            <div style="font-weight: 600;font-size: 25px;">{{responseResult?.practiceName}}</div>
            <div>{{responseResult?.practiceTitle}}</div>
          </div>
        </div>
        <div class="login-area__form flex-grow-1 mt-10">
          <template v-if="firstTextIsRead">
            <registration-from-qr :responseData="responseResult" @showImage="showImage" />
          </template>
          <template v-else>
            <br>
            <h3>{{ $t('loginForm.welcomeMessage') }}</h3>
            <br>
            <br>
            <p>{{ $t('loginForm.nutritionDescription') }}</p>
            <br>
            <br>
            <Button btn-bg="dark-green" tabindex="3" @click.native="firstTextIsRead = true" height="56" block dark>{{ $t('loginForm.startSurvey') }}</Button>
            <v-row class="mt-2">
              <v-col>
                <div class="registration-form__registration-link d-flex justify-center" style="color: #72767F;">{{ $t('loginForm.alreadyHaveAccount') }} <Link class="ml-2" to="/sign-in">{{ $t('loginForm.signIn') }}</Link></div>
              </v-col>
            </v-row>
          </template>
        </div>
      </div>
    </div>
    <div v-if="!firstTextIsRead" class="slider-area d-none d-lg-block">
      <div class="slider-area__carusel d-flex justify-center align-center">
        <carousel :items="items" />
      </div>
    </div>
    <div v-if="showBgImage" class="slider-area d-none d-lg-block">
      <img class="bg-image" src="@/assets/images/registered-bg.png" :alt="String($t('alt.registered_bg'))">
    </div>
  </div>
</template>

<script>
import Image from '@/mixins/Image'
import registrationFromQr from '@/components/layouts/forms/registration-from-qr'
import carousel from '@/components/layouts/carusel'
import Img from '@/components/elements/Img'
import Button from '@/components/elements/Button'
import Link from '@/components/elements/Link'
import { mapActions } from 'vuex'

export default {
  name: 'login',
  mixins: [Image],
  components: { registrationFromQr, Link, Img, carousel, Button },
  data: () => ({
    responseResult: {},
    firstTextIsRead: false,
    showBgImage: false,
    currentLang: null
  }),
  mounted () {
    this.setLocalizedTitle()
  },
  async created () {
    const { dynamicUrl } = this.$route.params
    const result = await this.getInfoByDynamicUrlQr({ dynamicUrl })
    this.responseResult = result.record
    this.currentLang = this.$i18n?.locale || 'en'
  },
  watch: {
    '$i18n.locale' () {
      this.setLocalizedTitle()
    }
  },
  methods: {
    ...mapActions(['getInfoByDynamicUrlQr', 'registrationFromQr']),
    setLocalizedTitle () {
      document.title = this.$t('titles.welcome')
    },
    showImage() {
      this.showBgImage = true
    },
    updateLanguage (lang) {
      if (this.$i18n.locale !== lang) {
        this.$i18n.locale = lang
        this.currentLang = lang
        localStorage.setItem('locale', this.$i18n.locale)
      }
    }
  },
  computed: {
    items () {
      return [
        {
          src: this.getImgWithExt(['images', 'slider', 'slide1', 'jpeg']),
          content: this.$t('slider.slide1')
        },
        {
          src: this.getImgWithExt(['images', 'slider', 'slide2', 'jpeg']),
          content: this.$t('slider.slide2')
        },
        {
          src: this.getImgWithExt(['images', 'slider', 'slide3', 'jpeg']),
          content: this.$t('slider.slide3')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  .login-area,
  .slider-area {
    width: 50%;
    height: 100vh;
  }
  .login-area {
    position: relative;
    background-color: #FFFFFF;

    .language-switcher {
      position: absolute;
      top: 23px;
      right: 23px;
      display: flex;
      column-gap: 2px;
      border-radius: 8px;
      background-color: #F7FAFC;
      padding: 2px;
      margin-left: auto;

      .button {
        ::v-deep .v-btn {
          width: 88px;
          color: #425466 !important;
          font-weight: 600 !important;
          font-size: 12px;
          line-height: 1;
          background-color: #F7FAFC !important;
          border-radius: 8px;
          padding: 9px 8px;
        }
      }
      .button.active-language {
        ::v-deep .v-btn {
          color: white !important;
          background-color: #008C89 !important;
        }
      }
    }

    &.width-all {
      width: 100%;

      .login-area__form-wrapper {
        width: 840px;
      }
    }
    @media (max-width: 960px) {
      width: 100%;
      padding: 0 30px;
    }
    &__form-wrapper {
      width: 554px;
      padding: 85px 0;
    }
    &__form {
      width: 100%;
      h3 {
        font-size: 28px;
        text-align: center;
      }
      p {
        font-size: 18px;
        text-align: center;
        max-width: 505px;
        margin: 0 auto;
      }
      .button {
        max-width: 380px;
        margin: 0 auto;
        ::v-deep .v-btn__content {
          font-weight: 600;
          letter-spacing: normal;
        }
      }
      .link {
        ::v-deep {
          a {
            color: #668BFF;
          }
        }
      }
    }
  }
  .slider-area {
    position: relative;
    background-color: $dark-green;
    overflow: hidden;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(151.33deg, #04B8B0 0%, rgba(4, 184, 176, 0) 43.71%);
      z-index: 1;
      pointer-events: none;
    }
    &__carusel {
      position: absolute;
      left: 15%;
      height: 100vh;
    }
  }
  .logo {
    ::v-deep {
      .v-image {
        border-radius: 50% !important;
      }
    }
  }
}
.bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
@media screen and (max-width: 500px) {
  .login {
    .login-area {
      &__form-wrapper {
        width: 100%;
      }
    }
  }
}
</style>
